/**
 * Note: To pass arguments to the callback inside a component use the following syntax:
 * <div v-in-viewport="(event) => handleInViewport(event, 'custom-argument')"></div>
 * Can only be used inside <ClientOnly></ClientOnly>
 */

export default defineNuxtPlugin(({ vueApp }) => {
  interface Target extends Element {
    __onViewportIntersection?: (...args: any[]) => void;
  }

  interface Entry extends IntersectionObserverEntry {
    target: Target;
  }

  const observer = new IntersectionObserver(
    (entries: Entry[]) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.__onViewportIntersection?.(entry);
        }
      }
    },
    {
      threshold: 0.8,
    },
  );
  vueApp.directive('inViewport', {
    mounted(element, binding) {
      const callback = binding.value;
      element.__onViewportIntersection = (data: unknown) => {
        callback?.(data);
        if (binding.modifiers.once) {
          observer.unobserve(element);
        }
      };
      observer.observe(element);
    },
    unmounted(element) {
      observer.unobserve(element);
    },
  });
});
